import type React from 'react';
import { useTranslation } from 'react-i18next';

const getAdmiralApi = () => {
  return typeof window !== 'undefined' ? (window as any).admiral : undefined;
};

const handleAdmiralCmpClick = (e: React.MouseEvent) => {
  e.preventDefault();
  const admiral = getAdmiralApi();
  if (admiral) {
    admiral('show', 'cmp.settings');
  }
};

export type CmpProps = {
  key: string;
  name: string;
  onClick: (e: React.MouseEvent) => void;
};

export const useCmpProps = (): CmpProps => {
  const { t } = useTranslation(['label']);
  return {
    key: 'admiral-cmp',
    name: t('CX_PRIVACY_OPTIONS'),
    onClick: handleAdmiralCmpClick,
  };
};
